module.exports = __webpack_public_path__ + "static/perlan-c749a81c6f885dbafa7a546facc4976a.png";